import * as React from "react";
import styled from "@emotion/styled";
import { css } from '@emotion/core';
import Hero from "./components/Hero";
import PassportBlock from "./components/PassportBlock";
import InnerPage from "../Core/components/InnerPage";
import { PrimaryLink } from "../Core/components/Buttons";
import { asset } from './components/helpers';
import mq from "../Styles/breakpoints";
import fontSize from "../Styles/text";

let padAndCenter = css`
      padding: 1em 2em;
      text-align: center;
      
      ${mq.large(`
        padding: 4em 2em;
      `)}
    `;
const LogoList = styled.div` 
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-bottom: 1.5em;
        
      & img {
        height: 50px;
        margin: 5px;
      }
    `;

const App = (props) => {
  return (
    <React.Fragment>
      <Hero />

      <div className="row">
        <div css={padAndCenter} className="large-6 columns">
          <img alt="PBS application featured on several mobile devices" src={asset("passport/tv.png")} />
          <h2>Watch on your big screen without cable</h2>
          <p>Search for the PBS App in your device's app library and download to
            stream today!</p>
          <LogoList>
            <a target="_blank" href="https://itunes.apple.com/us/app/pbs-video/id398349296">
              <img src={asset("passport/apple-tv.jpg")} alt="Apple TV logo" />
            </a>
            <a target="_blank" href="https://www.amazon.com/Public-Broadcasting-Service-PBS-Video/dp/B008Z2NVGK">
              <img src={asset("passport/fire-tv.jpg")} alt="Fire TV logo" />
            </a>
            <a target="_blank" href="https://help.pbs.org/support/solutions/12000002760">
              <img src={asset("passport/chromecast.jpg")} alt="Chromecast logo" />
            </a>
            <a target="_blank" href="https://channelstore.roku.com/details/23353/pbs">
              <img src={asset("passport/roku.jpg")} alt="Roku logo" />
            </a>
            <a target="_blank" href="https://help.pbs.org/support/solutions/articles/5000692515-can-i-access-passport-content-on-all-devices-and-platforms-">
              <img src={asset("/passport/samsungtv.jpg")} alt="Samsung SmartTV" />
            </a>
          </LogoList>
        </div>
        <div css={padAndCenter} className="large-6 columns">
          <img alt="PBS application featured on several mobile devices" src={asset("passport/pbs-mobile-app.png")} />
          <h2>Watch on your mobile devices</h2>
          <p>Download the PBS App on your phone or tablet and start streaming today!</p>
          <LogoList>
            <a target="_blank" href="https://itunes.apple.com/us/app/pbs-video/id398349296">
              <img src={asset("passport/mobile-apple.jpg")} alt="Download from Apple App Store logo" />
            </a>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.pbs.video">
              <img src={asset("passport/mobile-android.jpg")} alt="Get it on Google Play logo" />
            </a>
          </LogoList>
        </div>
      </div>

      <PassportBlock />
      <InnerPage>
        <div className="row">
          <div css={padAndCenter} className="large-6 columns">
            <h3>Need help streaming?</h3>
            <PrimaryLink target="_blank" href="https://help.pbs.org/support/home">Learn More</PrimaryLink>
          </div>
          <div css={padAndCenter} className="large-6 columns">
            <h3>Need to activate your PBS App?</h3>
            <PrimaryLink target="_blank" href="https://www.pbs.org/activate">Activate Now</PrimaryLink>
          </div>
        </div>
      </InnerPage>
    </React.Fragment>
  );
}

export default App;
